module.exports = __webpack_public_path__ + "static/img/fish52.995ee9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish52.png
// module id = l8nQ
// module chunks = 0